module.exports = __webpack_public_path__ + "media/images/img_top_mv_point01-ae14cda2967ed8d26e7087ed26aa0cd7.png";